import { request } from '../apis/';
import { HRReviewEmployeeGoalAssignment } from '../../models/models';

export interface CreateSubtaskRequest {
  title: string;
  description: string;
  deadline: string;
  priority: string;
  quarter: string;
}

export interface CreateSubtasksRequest {
  subtasks: CreateSubtaskRequest[];
}

export interface UpdateSubtaskRequest {
  title: string;
  description: string;
  status: string;
  priority: string;
  quarter: string;
  deadline: string;
}

export interface GoalReview {
  id: string;
  goalAssignmentGoalId: string;
  reviewerId: string;
  reviewerName: string;
  reviewDate: string;
  reviewText: string;
  rating: number;
  reviewerRole: string;
}

export const GoalsService = {
  getEmployeeGoals: (employeeId: string) => 
    request.get<HRReviewEmployeeGoalAssignment[]>(`/GoalAssignment/employee/${employeeId}`),
  
  createSubtasks: (goalAssignmentGoalId: string, data: CreateSubtasksRequest) =>
    request.post<any>(`/SubtasksAssignment/create/${goalAssignmentGoalId}`, data),
  
  updateSubtask: (subtaskId: string, data: UpdateSubtaskRequest) =>
    request.put<any>(`/SubtasksAssignment/update/${subtaskId}`, data),

  deleteSubtask: (subtaskId: string) =>
    request.delete<any>(`/SubtasksAssignment/delete/${subtaskId}`),

  getGoalReviews: (goalAssignmentGoalId: string) =>
    request.get<GoalReview>(`/GoalAssignment/goal-review/${goalAssignmentGoalId}`),

  acceptGoalAssignment: (goalAssignmentGoalId: string, status: string) =>
    request.post<any>(`/GoalAssignment/update-goal-acceptance/${goalAssignmentGoalId}`, JSON.stringify(status), {
      headers: { 'Content-Type': 'application/json' }
    }),
    
  updateGoalStatus: (goalAssignmentGoalId: string, status: string) =>
    request.post<any>(`/GoalAssignment/update-goal-status/${goalAssignmentGoalId}`, JSON.stringify(status), {
      headers: { 'Content-Type': 'application/json' }
    })
}; 